let mutations = {
    setPhone(state, data) {
        state.login.phone = data;
    },
    setHeadImg(state, data) {
        state.login.headimg = data;
    }
}
export default mutations;


// WEBPACK FOOTER //
// ./src/vuex/modules/sevenAbilityIntroduce/mutations.js